import base from './base2.repository';
export default {
    ...base,
    getCapabilities() {
        return this.get('capabilities');
    },
    getPositionCapabilities(positionId) {
        return this.get(`positions/${positionId}/capabilities`);
    },
    savePositionCapabilities(positionId, capabilities) {
        return this.post(`positions/${positionId}/capabilities`, {capabilities});
    },
    getMenus: () => base.get('security/menus'),
    getMenuOptions: () => base.get('security/menu-options'),
    getPositionOptions: () => base.get('security/position-options'),
    getProfileOptions: () => base.get('security/profile-options'),
    // getPositionCapabilities: () => base.get('security/position-capabilities'),
    getProfileCapabilities: () => base.get('security/profile-capabilities'),
}